// extracted by mini-css-extract-plugin
export default {"form":"CardNameEdit_form__u-nfn","field":"CardNameEdit_field__GU1Bq","buttons":"CardNameEdit_buttons__skrFq"};